import { cn } from "@/lib/utils";

export default function Plus({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 32 32'
            fill='none'
        >
            <path
                d='M16.3339 25.3336L15.6673 25.3336C15.2991 25.3336 15.0006 25.0352 15.0006 24.667L15.0006 17.0003L7.33394 17.0003C6.96584 17.0003 6.66734 16.7018 6.66734 16.3336L6.66734 15.667C6.66734 15.2988 6.96584 15.0003 7.33394 15.0003L15.0006 15.0003L15.0006 7.33366C15.0006 6.96547 15.2991 6.66699 15.6673 6.66699L16.3339 6.66699C16.7021 6.66699 17.0006 6.96547 17.0006 7.33366L17.0006 15.0003L24.6673 15.0003C25.0355 15.0003 25.334 15.2988 25.334 15.667L25.334 16.3336C25.334 16.7018 25.0355 17.0003 24.6673 17.0003L17.0006 17.0003L17.0006 24.667C17.0006 25.0352 16.7021 25.3336 16.3339 25.3336Z'
                fill='currentColor'
            />
        </svg>
    );
}
